import { render } from "./coach-wallet.vue?vue&type=template&id=16d62a4e"
import script from "./coach-wallet.vue?vue&type=script&lang=js"
export * from "./coach-wallet.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__